// Calculate distance between two points using Haversine formula
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Earth's radius in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
};

export const calculateRouteDistance = (trackPoints) => {
  if (!trackPoints?.length) return 0;
  if (trackPoints.length < 2) return 0;
  
  let totalDistance = 0;
  for (let i = 1; i < trackPoints.length; i++) {
    const prev = trackPoints[i - 1];
    const curr = trackPoints[i];
    
    // Skip invalid points
    if (!prev.latitude || !prev.longitude || !curr.latitude || !curr.longitude) {
      continue;
    }
    
    totalDistance += calculateDistance(
      prev.latitude,
      prev.longitude,
      curr.latitude,
      curr.longitude
    );
  }
  
  return totalDistance * 1000; // Convert to meters
};

export const formatDistance = (distance) => {
  if (!distance) return '0 km';
  
  // Convert to kilometers and format with 1 decimal place
  const km = (distance / 1000).toFixed(1);
  return `${km} km`;
};

export const calculateDistanceAlongRoute = (trackPoints, poiCoords) => {
  if (!trackPoints?.length) return 0;
  
  let minDistance = Infinity;
  let closestPoint = null;
  
  // Find closest point on route to POI
  trackPoints.forEach((point, index) => {
    const distance = calculateDistance(
      point.latitude,
      point.longitude,
      poiCoords.latitude,
      poiCoords.longitude
    );
    
    if (distance < minDistance) {
      minDistance = distance;
      closestPoint = { index, point };
    }
  });
  
  // Calculate distance along route to closest point
  let distanceAlongRoute = 0;
  for (let i = 0; i < closestPoint.index; i++) {
    distanceAlongRoute += calculateDistance(
      trackPoints[i].latitude,
      trackPoints[i].longitude,
      trackPoints[i + 1].latitude,
      trackPoints[i + 1].longitude
    );
  }
  
  return distanceAlongRoute * 1000; // Convert to meters
};